import * as z from 'zod';
import { BILLING_RUN_TYPE } from 'src/features/billingRuns/utils/types';

export type TriggerBillingRunFormSchemaValues = z.infer<typeof triggerBillingRunFormSchema>;
export const triggerBillingRunFormSchema = z.object({
    type: z.enum(BILLING_RUN_TYPE),
    /** Omitted means today. */
    business_date: z.string().optional().nullable(),
});
